export default {"src":"/_next/static/media/mobile_pop_up.cced003f.gif","height":300,"width":480,"blurWidth":0,"blurHeight":0};